import React from "react";
import './SectionImage.css';
import WhiteBlock from "../../WhiteBlock/WhiteBlock.js";

const SectionTitle = (props)=>{
    return(
     <section className="section-image">
             <WhiteBlock positiont={props.topBlock}/>
            <div className="title-conteiner">
                <div className="titleHero-imagePhoto">
                <img src={props.photo} alt="zdjęcie przedstawiające park linowy" />
                </div>
                <div className="titleHero-imageOpacity"></div>
                <div className="text-conteiner">
                    <h2>{props.title}</h2>
                    <hr/>
                    <p>{props.description}</p>
                    <hr/>
                </div>
            </div>
            <WhiteBlock positiont={props.bottomBlock}/>
    </section>
    )
}

export default SectionTitle;